import React from "react";
import { connect } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { Actions as reportActions } from "../core/redux/ducks/report";
import { Actions as articleActions } from "../core/redux/ducks/article";
import { Creators as appActions } from "../core/redux/ducks/app";
import { useAppContext } from "../libs/contextLib";
import { SearchField } from "./SearchField";
import AppBar from "@material-ui/core/AppBar";
import {
  Toolbar,
  makeStyles,
  Grid,
  IconButton,
  Button,
  Box,
} from "@material-ui/core";
import PlusIcon from "@material-ui/icons/Add";
import { UserActions } from "./UserActions";
import FormModal from "./FormModal";
import { useSearchContext } from "../contexts/Search";
import useLanguage from "../hooks/useLanguage";
import { LANG_EN, LANG_DE } from "../utils/translation";

function NewHeader({
  showHideToggleArticlePaper,
  isArticlePaperOpen,
  user,
  articleData,
  createArticle,
}) {
  const history = useHistory();
  const { isAuthenticated, userHasAuthenticated } = useAppContext();
  const [searchKey, setSearchKey] = React.useState("");
  const [isModalOpen, setModalOpen] = React.useState(false);
  const classes = useStyles();
  let location = useLocation();
  const { language, setLanguage } = useLanguage();
  const { translate } = language;

  React.useEffect(() => {
    const defaultKeyWord =
      history.location.state && history.location.state.keywords
        ? history.location.state.keywords
        : "";
    if (isArticlePaperOpen && location.pathname !== "/search") {
      showHideToggleArticlePaper();
      setSearchKey(defaultKeyWord);
    } else {
      if (defaultKeyWord) setSearchKey(defaultKeyWord);
    }
  }, [history.location]);

  const { setSearchText } = useSearchContext();

  function handleSubmit(e) {
    e.preventDefault();
    setSearchText(searchKey);
    if (user.isPremium) {
      history.push({
        pathname: "/search",
        state: { keywords: searchKey, action: "search" },
      });
    } else {
      history.push({
        pathname: "/articles",
        state: { keywords: searchKey, action: "search" },
      });
    }
  }

  const handleAddArticle = (keyword) => {
    const stateParams = { keywords: keyword, action: "save" };
    createArticle(keyword);
    history.push({
      pathname: "/articles",
      state: stateParams,
    });
  };

  const handleLangSelect = (lang) => {
    if (lang === "en") {
      setLanguage({
        lang: "en",
        translate: LANG_EN,
      });
    }
    if (lang === "de") {
      setLanguage({
        lang: "de",
        translate: LANG_DE,
      });
    }
  };

  if (!isAuthenticated || location.pathname === "/editor") return null;
  return (
    <AppBar color="secondary" position="fixed" className={classes.appbar}>
      <Toolbar variant="dense" className={classes.toolbar}>
        <IconButton
          onClick={() =>
            history.push({
              pathname: "/articles",
              state: { keywords: searchKey, action: "search" },
            })
          }
        >
          <img src="images/faktual_logo_sm.png" alt="img" width="30px" />
        </IconButton>

        <Grid container alignContent="center">
          <Grid item md={4} xs={3}>
            <Grid
              container
              alignContent="center"
              justify="space-around"
              className={classes.buttons}
            >
              {/* <Grid item>
                <Link to="/articles" className={classes.link}>
                  <SvgIcon>
                    <FoldersIcon width={25} height={25} />
                  </SvgIcon>
                  Ordner
                </Link>
              </Grid> */}
              {/* <Grid
                item
                onClick={() =>
                  history.push({
                    pathname: "/search",
                    state: { keywords: searchKey, action: "search" },
                  })
                }
                className={classes.searchButton}
              >
                <SearchIcon />
                Selected
              </Grid> */}
            </Grid>
          </Grid>
          <Grid item md={6} xs={8}>
            <Grid container direction="row" spacing={1}>
              <Grid item className={classes.searchField}>
                <SearchField
                  value={searchKey}
                  onChange={setSearchKey}
                  label={translate.search_placeholder}
                  onSubmit={(e) => handleSubmit(e)}
                />
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.addArticle}
                  onClick={() => setModalOpen(true)}
                >
                  <PlusIcon />
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box display="flex">
          <IconButton size="small" onClick={() => handleLangSelect("en")}>
            <img
              src="images/eng_flag.png"
              alt="eng_flag"
              width="20px"
              className={
                language.lang === "en"
                  ? classes.langIconSelected
                  : classes.langIcon
              }
            />
          </IconButton>
          <IconButton size="small" onClick={() => handleLangSelect("de")}>
            <img
              src="images/de_flag.png"
              alt="de_flag"
              width="20px"
              className={
                language.lang === "de"
                  ? classes.langIconSelected
                  : classes.langIcon
              }
            />
          </IconButton>
        </Box>
        <UserActions user={user} userHasAuthenticated={userHasAuthenticated} />
        <FormModal
          show={isModalOpen}
          onHide={() => setModalOpen(false)}
          error={articleData.error}
          addArticle={handleAddArticle}
        />
      </Toolbar>
    </AppBar>
  );
}

const useStyles = makeStyles((theme) => ({
  appbar: {
    paddingLeft: "8px",
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  },
  appbarSmall: {
    // boxShadow: "unset",
    width: "50%",
    left: 0,
  },
  toolbar: {
    // boxShadow: "unset",
    paddingLeft: "0px",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  buttons: {
    height: "100%",
    padding: "0 25%",
  },
  addArticle: {
    minWidth: "auto",
  },
  searchField: {
    width: "400px",
  },
  searchButton: {
    cursor: "pointer",
  },
  link: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "88px",
    color: "white",
    "&:hover": {
      color: "white",
    },
  },
  langIcon: {
    opacity: 0.2,
  },
  langIconSelected: {
    opacity: 0.8,
  },
}));

const mapStateToProps = (state) => {
  return {
    reportData: state.report,
    isArticlePaperOpen: state.app.isArticlePaperOpen,
    user: state.user.user,
    articleData: state.article,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReports: (params, id) =>
      reportActions.fetchReports(dispatch, params, id),
    resetReports: () => reportActions.resetReports(dispatch),
    showHideToggleArticlePaper: () =>
      dispatch(appActions.showHideToggleArticlePaper()),
    createArticle: (name) =>
      articleActions.saveArticle(dispatch, { name }, null),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewHeader);
